/* istanbul ignore file */
// This file was generated by figma/utils.mjs
import React, { FunctionComponent } from 'react'

export const Globe: FunctionComponent = (): JSX.Element => (
  <React.Fragment>
    <path
      d='M12 0C5.383 0 0 5.383 0 12C0 18.617 5.383 24 12 24C18.617 24 24 18.617 24 12C24 5.383 18.617 0 12 0ZM21.949 11H18.473C18.335 7.79 17.542 4.98 16.332 3.001C19.395 4.482 21.597 7.468 21.949 11ZM11 2.3V11H7.525C7.734 6.531 9.315 3.26 11 2.3ZM11 13V21.7C9.315 20.74 7.734 17.469 7.525 13H11ZM13 21.7V13H16.475C16.266 17.469 14.685 20.74 13 21.7ZM13 11V2.3C14.685 3.26 16.266 6.531 16.475 11H13ZM7.667 3.001C6.458 4.98 5.664 7.79 5.526 11H2.051C2.403 7.468 4.605 4.482 7.667 3.001ZM2.051 13H5.527C5.665 16.21 6.458 19.02 7.668 20.999C4.605 19.518 2.403 16.532 2.051 13ZM16.333 20.999C17.542 19.02 18.336 16.21 18.474 13H21.95C21.597 16.532 19.395 19.518 16.333 20.999Z'
      fill='currentColor'
    />
  </React.Fragment>
)
